import http from "../api";

class FilesDataService {
    getAnexos(type, id) {
        return http({
            'url':'/files/send/'+type+'/'+id,
            'method':'GET',
            responseType: 'arraybuffer',
            withCredentials:true
        });
    }

    updateAnexos(type, idAti, idAnex){
        return http({
            'url':'/files/remove/'+type+'/'+idAti+'/'+idAnex,
            'method':'DELETE'
        })
    }
}

export default new FilesDataService();